import { Link } from "react-router-dom";
import { Stack, Badge, Text, Group, Paper, ThemeIcon } from "@mantine/core";
import { IconUser, IconUserCheck, IconUserPlus, IconUserX } from "@tabler/icons-react";
import moment from "moment";
import classes from './CrudUserDate.module.css';

export const CrudUserDate = ({ label, userId, userName, date, useNewLayout }: { label: string; userId: string; userName: string; date: Date | null; useNewLayout?: boolean }) => {
	const icon = label === "Created" ? <IconUserPlus size={18} /> : label === "Deleted" ? <IconUserX size={18} /> : <IconUserCheck size={18} />;
	const iconColour = label === "Created" ? "green" : label === "Deleted" ? "red" : "violet";
	
	return <>
		{useNewLayout && (
		<Paper component={Link} to={{ pathname: `/users/${userId}` }} p="md" radius="md" className={classes['infoPaper']}>
			<Group gap="xs" wrap="nowrap" align="start">
				<ThemeIcon variant="light" color={iconColour} size="lg" radius="md">
					{icon}
				</ThemeIcon>
				<div>
					<Text size="xs" c="dimmed" tt="uppercase" fw={700}>
						{label}
					</Text>
					<Text fw={500}>{userName || "Unknown"}</Text>
					<Text size="sm" c="dimmed">{moment.utc(date).local().format("LLL")}</Text>
				</div>
			</Group>
		</Paper>
		)}
		{!useNewLayout && (
		<Stack gap={5}>
			<Text fz="xs" fw="700" tt="uppercase" c="dimmed">{label}</Text>
			<Stack gap={5}>
				<Text fz="sm">{moment.utc(date).local().format("LLL")}</Text>
				<Link to={{ pathname: `/users/${userId}` }} className={classes['link']}>
					<Badge size="lg" fz="sm" radius="sm" leftSection={<IconUser size={14} />}>{userName}</Badge>
				</Link>
			</Stack>
		</Stack>
		)}
	</>
}